import React from 'react';
import { DashboardProject } from '../../../../types/project';
import { BuckleArrestorSetup } from './BuckleArrestorSetup';
import { PipeInPipeSetup } from './PipeInPipeSetup';
import { BulkHeadSetup } from './BulkHeadSetup';

interface FabricationSetupProps {
  project: DashboardProject;
}

export const FabricationSetup: React.FC<FabricationSetupProps> = ({ project }) => {
  if (!project.fabricationOptions?.buckleArrestor && !project.fabricationOptions?.pipeInPipe) {
    return null;
  }

  return (
    <div className="space-y-12">
      {project.fabricationOptions?.buckleArrestor && (
        <BuckleArrestorSetup project={project} />
      )}
      {project.fabricationOptions?.pipeInPipe && (
        <PipeInPipeSetup project={project} />
      )}
      {project.fabricationOptions?.bulkhead && (
        <BulkHeadSetup project={project} />
      )}
    </div>
  );
}; 